import { Box, CircularProgress, Typography } from "@mui/material"
import { MailOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"

import { pluralize } from "../../../../../utils/stringUtils"

interface ReSendDialogTitleProps {
  totalContacts: number
  totalAccounts: number
  isFetching?: boolean
  title: string
}

const SendDialogTitle: FC<ReSendDialogTitleProps> = ({ title, totalAccounts, totalContacts, isFetching }) => {
  return (
    <Box className='flex flex-col items-center'>
      <MailOutlined className='size-10 text-primary' />

      <Typography variant='h6' className='mt-4 text-center text-xl font-normal text-primary'>
        {title}
      </Typography>

      {isFetching ? (
        <Box className='flex justify-center py-4'>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Typography variant='body2' className='mt-6 text-base font-normal text-gray-700'>
          This price change will be sent to
          <strong>
            {" "}
            {totalContacts} subscribed {pluralize(totalContacts, "contact", "contacts")}{" "}
          </strong>
          across
          <strong>
            {" "}
            {totalAccounts} {pluralize(totalAccounts, "account", "accounts")}
          </strong>
          .
        </Typography>
      )}
    </Box>
  )
}

export default SendDialogTitle
